export const SIGNATURE_STATE_TOOLBAR_AGREE_TERMS = 'SIGNATURE_STATE_TOOLBAR_AGREE_TERMS';
export const SIGNATURE_STATE_TOOLBAR_DECLINE = 'SIGNATURE_STATE_TOOLBAR_DECLINE';
export const SIGNATURE_STATE_TOOLBAR_COMPLETE = 'SIGNATURE_STATE_TOOLBAR_COMPLETE';

export const SIGNATURE_STATE_TOOLBAR_MODE_AGREE = 'SIGNATURE_STATE_TOOLBAR_MODE_AGREE';
export const SIGNATURE_STATE_TOOLBAR_MODE_DECLINED = 'SIGNATURE_STATE_TOOLBAR_MODE_DECLINED';
export const SIGNATURE_STATE_TOOLBAR_MODE_SIGN = 'SIGNATURE_STATE_TOOLBAR_MODE_SIGN';
export const SIGNATURE_STATE_TOOLBAR_MODE_DONE = 'SIGNATURE_STATE_TOOLBAR_MODE_DONE';
export const SIGNATURE_STATE_TOOLBAR_MODE_COMPLETED = 'SIGNATURE_STATE_TOOLBAR_MODE_COMPLETED';



// WEBPACK FOOTER //
// ./src-react/SignatureStateToolbar/SignatureStateToolbarConstants.jsx